export default __webpack_public_path__ + "static/media/google.86682d98ec7253f9f5e8e3dfef6541cf.svg";